<app-generic-sidebar
  [initialCollapsed]="isCollapsedSignal()"
  [sections]="sections"
  [baseRoutePath]="baseRoutePath"
  [isDisabledFn]="isDisabledFn"
  (isCollapsedChange)="isCollapsedChange.emit($event)"
  (homeNavigate)="homeNavigate.emit()">
  <ng-template sidebarHeader>
    <div class="flex flex-col gap-(--gap-normal) transition-opacity duration-50">
      <h1 class="font-bold text-lg">Démo Sidebar</h1>
      <div class="flex flex-wrap gap-(--gap-normal)">
        <p-tag [rounded]="true" severity="info">Documentation</p-tag>
        <p-tag [rounded]="true" severity="secondary">v1.0.0</p-tag>
      </div>
    </div>
  </ng-template>
  <ng-template sidebarFooter>
    <ces-button-secondary
      (onClick)="toggleActiveRoute.emit()"
      size="small"
      icon="refresh"
      label="Changer route active"
      iconPosition="right" />
  </ng-template>
</app-generic-sidebar>
